const Error = () => {
  return (
    <p className="error">
      <span>⚠️</span> There was an error fetching questions. Please try again.
    </p>
  );
};

export default Error;
